import type { ListingDraft } from "../../shared/schemas/listings.ts";
import { api } from "./api.ts";

export type ImageInfo = {
  id: string;
  r2_key: string;
  width: number;
  height: number;
  sort_order: number;
  url: string;
};

export type OwnerListing = {
  title: string;
  description: string | null;
  category_id: number | null;
  condition: "new" | "like_new" | "good" | "fair" | null;
  city_id: number | null;
  district: string | null;
  quantity: number;
  start_price: number | null;
  duration_s: number | null;
  start_mode: "now" | "drop";
  id: string;
  status: "draft" | "scheduled" | "active" | "sold_out" | "expired" | "cancelled";
  quantity_remaining: number;
  start_at: number | null;
  end_at: number | null;
  floor_price: number;
  is_drop: boolean;
  watch_count: number;
  alert_count: number;
  published_at: number | null;
  ended_at: number | null;
  images: ImageInfo[];
  ladder?: {
    bucket_size: number;
    total: number;
    buckets: { from: number; to: number; count: number }[];
  } | null;
};

export const createDraft = () => api<{ id: string }>("/api/listings", { body: {} });
export const loadOwner = (id: string) => api<OwnerListing>(`/api/listings/${id}/owner`);
export const saveDraft = (id: string, patch: ListingDraft) =>
  api<{ ok: true }>(`/api/listings/${id}`, { method: "PUT", body: patch });
export const publishDraft = (id: string) =>
  api<OwnerListing>(`/api/listings/${id}/publish`, { body: {} });
export const dropInfo = () =>
  api<{ next: number; for_listing: number; queued: number; server_ts: number }>(
    "/api/listings/drop",
  );
export const removeImage = (id: string, imageId: string) =>
  api(`/api/listings/${id}/images/${imageId}`, { method: "DELETE" });
export const reorderImages = (id: string, imageIds: string[]) =>
  api(`/api/listings/${id}/images/order`, { method: "PUT", body: { image_ids: imageIds } });

export async function uploadImage(id: string, blob: Blob): Promise<ImageInfo> {
  const form = new FormData();
  form.set("file", blob, "image");
  const res = await fetch(`/api/listings/${id}/images`, {
    method: "POST",
    headers: { "X-Yabe": "1" },
    body: form,
    credentials: "same-origin",
  });
  const data = (await res.json()) as ImageInfo & { error?: string };
  if (!res.ok) throw new Error(data.error ?? "upload_failed");
  return data;
}
